import type { CSSProperties } from 'react';
import { setLang, useLang, type Lang } from '.';

/** The app's own font stack (the template root's): the corner toggle sits outside it. */
const FONT = "Nudica,'Instrument Sans',system-ui,sans-serif";

// The language switch (23 Oct 2026): "ES | EN" in the header's style (the outlined pill of "Salir"). `dark` for light
// backgrounds (the sign-in screens); `corner` pins it to the top right of pages without a header bar.
// `compact` (phones): one button with the other language, so the header's name and "Salir" keep their line.
export function LangToggle({ dark = false, corner = false, compact = false }: { dark?: boolean; corner?: boolean; compact?: boolean }) {
  const lang = useLang(), fg = dark ? '#03033B' : '#FFFFFF', bg = dark ? '#FFFFFF' : '#03033B';
  if (compact) {
    const other: Lang = lang === 'es' ? 'en' : 'es';
    return (
      <button type="button" data-lang-toggle="" lang={other} aria-label={other === 'en' ? 'English' : 'Español'} onClick={() => setLang(other)}
        style={{ background: 'transparent', color: fg, border: `1px solid ${fg}`, borderRadius: 999, padding: '5px 8px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: FONT, flexShrink: 0 }}>
        {other.toUpperCase()}
      </button>
    );
  }
  const wrap: CSSProperties = { display: 'inline-flex', border: `1px solid ${fg}`, borderRadius: 999, overflow: 'hidden', flexShrink: 0,
    ...(corner ? { position: 'fixed', top: 16, right: 16, zIndex: 50 } : {}) };
  const btn = (l: Lang): CSSProperties => ({ background: lang === l ? fg : 'transparent', color: lang === l ? bg : fg, border: 'none',
    padding: '5px 10px', fontSize: 13, fontWeight: 600, cursor: lang === l ? 'default' : 'pointer', fontFamily: FONT, letterSpacing: '.04em' });
  return (
    <div role="group" aria-label={lang === 'en' ? 'Language' : 'Idioma'} data-lang-toggle="" style={wrap}>
      {(['es', 'en'] as const).map(l => (
        <button key={l} type="button" lang={l} aria-pressed={lang === l} title={l === 'es' ? 'Español' : 'English'} onClick={() => setLang(l)} style={btn(l)}>{l.toUpperCase()}</button>
      ))}
    </div>
  );
}
